<template>
  <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="80" class="edit-win">
    <FormItem label="用户名" prop="username">
      <Input v-model="formValidate.username" placeholder="请输入您的用户名"></Input>
    </FormItem>
    <FormItem label="密码" prop="password">
      <Input type="password" v-model="formValidate.password" placeholder="请输入您的密码"></Input>
    </FormItem>
    <FormItem label="操作人员名称" prop="username">
      <Input v-model="formValidate.name" placeholder="请输入您的操作人员名称"></Input>
    </FormItem>
    <FormItem v-if="isShowAp" label="确认密码" prop="againpassword">
      <Input type="password" v-model="formValidate.againpassword" placeholder="请输入您的确认密码"></Input>
    </FormItem>
    <FormItem label="经销商名称" prop="dealername">
      <Input v-model="formValidate.dealername" placeholder="请输入您的经销商名称"></Input>
    </FormItem>
    <FormItem label="经销商地址" prop="dealeraddress">
      <Input v-model="formValidate.dealeraddress" placeholder="请输入您的经销商地址"></Input>
    </FormItem>
    <FormItem label="角色" prop="roleIdList">
      <CheckboxGroup v-model="formValidate.roleIdList">
        <Checkbox v-for="item in roleList" :label="item.roleId" :key="item.roleId">{{item.roleName}}</Checkbox>
      </CheckboxGroup>
    </FormItem>
    <FormItem label="状态" prop="status">
      <RadioGroup v-model="formValidate.status">
        <Radio :label="1">正常</Radio>
        <Radio :label="0">禁用</Radio>
      </RadioGroup>
    </FormItem>
    <FormItem>
      <Button @click="submitInfo" type="primary">确定</Button>
      <Button @click="$router.go(-1)" style="margin-left: 8px">返回</Button>
    </FormItem>
  </Form>
</template>

<script>
export default {
  data () {
    return {
      isShowAp: true,
      tempPassword: '',
      formValidate: {
        username: '',         //用户
        password: '',         //密码
        againpassword: '',    //再次密码
        email: '',            //邮箱
        mobile: '',           //手机
        roleIdList: [],       //角色数组
        status: '',           //状态
        name: '',
        pid:'',
        groupId:''            //分组id
      },
      roleList: '',
      ruleValidate: {
        username: [
          { required: true, message: '用户名不能为空', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '密码不能为空', trigger: 'blur' }
        ],
        againpassword: [
          { required: true, message: '确认密码不能为空', trigger: 'blur' }
        ],
        name: [
          { required: true, message: '名称不能为空', trigger: 'blur' }
        ],
        roleIdList: [
          { required: true, type: 'array', min: 1, message: '角色不能为空', trigger: 'blur' }
        ],
        status: [
          { required: true, type: 'number', message: '状态不能为空', trigger: 'blur' }
        ],
      }
    }
  },
  watch: {
    '$route.query.id' () {
      this.getDetail()
    },
    'formValidate.password' (newval, oldval) {
      if(oldval!= "") {
        this.isShowAp = true
      }
    }
  },
  created() {
    if(this.$route.query.id) {
      this.isShowAp = false
    }
    if(this.$route.query.groupid) {
      this.formValidate.groupid = this.$route.query.groupid
    }
  },
  mounted () {
    this.getRoleList()
    this.getDetail()
  },
  methods: {
    getDetail(){
      if(this.$route.query.id) {
        this.$Loading.start()
        this.$axios.get('/sys/user/info/' + this.$route.query.id)
          .then(function (response) {
          if(response.data.success){
              if(!response.data.data.roleIdList) {
                response.data.data.roleIdList = []
              }
              this.formValidate = response.data.data
              this.$Loading.finish()
          }else{
            this.$Message.error(response.data.errMsg)
            this.$Loading.error()
          }
          this.table_loading = false
        }.bind(this))
      } else {
        this.formValidate.pid = this.$route.query.groupid
      }
    },
    getRoleList(){
      this.$Loading.start()
      this.$axios.get('/sys/role/select')
        .then(function (response) {
        if(response.data.success){
            this.roleList = response.data.data
            this.$Loading.finish()
        }else{
          this.$Message.error(response.data.errMsg)
          this.$Loading.error()
        }
        this.table_loading = false
      }.bind(this))
    },
    submitInfo () {
      this.$refs.formValidate.validate((valid) => {
        if (valid) {
          this.$Loading.start()
          let url = ''
          this.$route.query.id ? url='sys/user/update' : url='sys/user/save'
          this.$axios.post(url,this.formValidate)
          .then(function (response) {
            if(response.data.success){
              this.$Message.success(response.data.data)
              this.$Loading.finish()
              this.$router.go(-1)
            }else{
              this.$Message.error(response.data.errMsg)
              this.$Loading.error()
            }
          }.bind(this))
        }
      })
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/views/user/edit.vue